import { contentSoundsBaseUrl } from "site/services/content-base-url";

/** Storage path without file extension (same convention as exercise images). */
export function normalizeAudioStoragePath(path: string): string {
  return path.trim().replace(/\.aac$/i, "");
}

export function formatAudioDisplayPath(path: string): string {
  const base = normalizeAudioStoragePath(path);
  return base ? `${base}.aac` : "";
}

export function getUploadVoiceUrl(file: string): string {
  const base = normalizeAudioStoragePath(file);
  if (!base) {
    return "";
  }
  return `${contentSoundsBaseUrl()}/${base}.aac`;
}
